import styled from "styled-components"

import Photo0301 from "../../img/03_01.png"
import Photo0302 from "../../img/03_02.png"
import Photo0303 from "../../img/03_03.png"
import Photo0304 from "../../img/03_04.jpg"
import Photo0305 from "../../img/03_05.jpg"
import Photo0306 from "../../img/03_05.jpg"
import Photo0307 from "../../img/03_05.jpg"

const ContentBase03 = styled.div`
  background: #111;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
`

function SubMenuContent03() {
  return (
    <ContentBase03>
      <div className="typobase02">
        TV-APP은 PC와 모바일과는 달리 리모콘만으로 모든 인터페이스를 조정합니다.
        모든 GUI부터 운영 디자인까지 인지가 쉽게 만들어야 하고, APP 사용에
        조금이라도 다방면으로 고민하게 만드는 요소를 없애서 1차원적인 단순한
        디자인으로 구성을 해야 합니다. KTH에서 운영하는 K-Shopping은 2013년에
        시작한 최초의 채널형 T-커머스로, 영상송출만으로 운영되는 홈쇼핑과는 달리
        리모콘 인터페이스가 적용된 양방향 데이터 TV쇼핑입니다.
      </div>
      <div className="typotitle">Olleh K-Shopping APP</div>
      <div className="video-wrap">
        <iframe
          autoPlay="1"
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/xhUZHrE2gro"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <img src={Photo0301} className="photobase" alt="Photo0301"></img>
      <img src={Photo0302} className="photobase" alt="Photo0302"></img>
      <img src={Photo0303} className="photobase" alt="Photo0303"></img>
      <img src={Photo0304} className="photobase" alt="Photo0304"></img>
      <div className="typotitle">Skylife K-Shopping APP</div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/vngEbKpqTAQ"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <img src={Photo0305} className="photobase" alt="Photo0305"></img>
      <img src={Photo0306} className="photobase" alt="Photo0306"></img>
      <img src={Photo0307} className="photobase" alt="Photo0307"></img>
    </ContentBase03>
  )
}

export default SubMenuContent03
